var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAnalysis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.889.333H7.112C2.866.333.334 2.865.334 7.112v9.765c0 4.258 2.532 6.79 6.778 6.79h9.765c4.247 0 6.779-2.532 6.779-6.779V7.113c.011-4.247-2.52-6.779-6.767-6.779zm.805 11.119a.812.812 0 0 1-.817.816.812.812 0 0 1-.816-.816v-.21l-3.174 3.173a.802.802 0 0 1-.653.234.775.775 0 0 1-.595-.362l-1.19-1.774-2.777 2.777a.784.784 0 0 1-.571.234.813.813 0 0 1-.572-.234.824.824 0 0 1 0-1.155l3.477-3.476a.802.802 0 0 1 .653-.234.775.775 0 0 1 .595.362l1.19 1.773 2.462-2.462h-.21a.812.812 0 0 1-.817-.816c0-.455.362-.817.817-.817h2.17a1 1 0 0 1 .315.059.825.825 0 0 1 .443.443c.047.105.058.21.058.315v2.17h.012z",
    fill: "#0044EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalysis);
export default __webpack_public_path__ + "static/media/icon_analysis.840338d9e9d9c93e5893be4c0dc5b8ad.svg";
export { ForwardRef as ReactComponent };